export default __webpack_public_path__ + "static/media/Aeonik-Medium.4c8d00e2.woff2";